import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-illustrative/lamp.svg';
import { mapGetters, mapMutations } from 'vuex';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import SearchSeo from '~/components/functional/Seo/SearchSeo.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import ResultsDataProvider from '~/components/specific/Providers/ResultsDataProvider.vue';
import getCorvusProviderName from '~/helpers/search-data-helpers';
import { componentList, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
var components = {};
componentList().forEach(e => {
  components[e.type || e.name] = slug => ({
    component: import("~/components/organisms/Editorial/".concat(slug))
  });
});
export default {
  components: {
    MdmBreadcrumb,
    SearchSeo,
    CategoryLoading,
    CategoryTemplate,
    ResultsDataProvider
  },
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=86400, public'
  }),

  asyncData(_ref) {
    return _asyncToGenerator(function* () {
      var {
        app: {
          apolloProvider
        },
        store
      } = _ref;

      try {
        var definition = typeDefinition('noresult');
        var {
          results: [{
            id,
            data
          }]
        } = yield fetchContent(store, {
          type: 'noresult'
        });
        var slices = yield buildSlices(definition, data, apolloProvider.defaultClient, store);
        return {
          type: definition.type,
          template: {
            path: definition.path,
            data
          },
          id,
          slices
        };
      } catch (e) {
        console.log(e);
      }

      return false;
    })();
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    descriptionSeo() {
      return this.description && this.description.seo && this.description.seo.meta_description ? this.description.seo.meta_description : '';
    },

    dataProvider() {
      if (getCorvusProviderName(this) === 'algolia') {
        return false;
      }

      return true;
    },

    speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "search";'
      };
      return luxConfig;
    }

  }),

  created() {
    if (this.template && this.template.path) {
      this[this.type] = () => components[this.type](this.template.path);
    }

    if (this.slices) {
      this.slices.forEach((_ref2) => {
        var {
          type,
          path
        } = _ref2;

        this[type] = () => components[type](path);
      });
    }

    this.setTcvarsTemplateName('listproduct_keyword');
  },

  methods: _objectSpread({
    currentComponent(arg) {
      return this[arg];
    }

  }, mapMutations({
    setTcvarsTemplateName: 'category/SET_TCVARS_TEMPLATE_NAME'
  })),

  head() {
    return {
      script: [this.speedcurveConfig]
    };
  }

};